import React from "react";

export default function MSAccess_Space() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">MSAccess_Space</h1>
      <p>This is the MSAccess_Space component generated from the SQL JSON.</p>
    </div>
  );
}
